import React, { Component }  from 'react';
import PropTypes from 'prop-types';


class Img extends Component {

  static propTypes = {
    defaultSrc : PropTypes.string,
    src : PropTypes.string
  }

  static defaultProps = {
    defaultSrc : require('../assets/default.png')
  }

  constructor(props) {
    super(props);
    this.state = { 
        imageUrl: this.props.src || this.props.defaultSrc
    };
  }

  componentWillReceiveProps(newProps){
    if(this.props.src !== newProps.src){
      this.setState({imageUrl : newProps.src});
    }
  }

  handleImageLoaded() {
  
  }

  handleImageErrored(e) {
    // console.warn('handleImageErrored --> ', e);
      this.setState({ 
          imageUrl: this.props.defaultSrc
      });
  }
  render() {
    let _props ={ ...this.props};
    delete _props.src;
    delete _props.defaultSrc;
    return (
      <img {..._props}
          alt=''
          src={this.state.imageUrl}
          onLoad={this.handleImageLoaded.bind(this)}
          onError={this.handleImageErrored.bind(this)}
      />
  );
  }
}

export default Img

